import { FormControl } from "@angular/forms";

export function capitalizeFirstLetter(str: string): string {
  const capitalized = str.replace(/^./, str[0].toUpperCase());

  return capitalized;
}

export function keyPressCharacters(event: any): boolean {
  var inp = String.fromCharCode(event.keyCode);
  if (/[a-zA-Z .]/.test(inp)) {
    return true;
  } else {
    event.preventDefault();
    return false;
  }
}

export function keyPressTH(event: any): boolean { //excludeThaiCharacters
  var inp = String.fromCharCode(event.keyCode);
  if (/[^\u0E00-\u0E7F]/.test(inp)) {
    return true;
  } else {
    event.preventDefault();
    return false;
  }
}

export function checkAndRemoveTitleWording(keyword: string): string {
  if (keyword) {
    if (keyword.toUpperCase().includes('MISS') || keyword.toUpperCase().includes('MRS.')) {
      keyword = keyword.trim().substring(4);
    } else if (keyword.toUpperCase().includes('MS.') || keyword.toUpperCase().includes('MR.')) {
      keyword = keyword.trim().substring(3);
    }
    keyword = keyword.replace(/[^A-Za-z .]/ig, '');
    return keyword.trim();
  } else {
    return keyword;
  }
}

export function equalsIgnoringCase(text: string, other: any): boolean {
  return text.localeCompare(other, undefined, { sensitivity: 'accent' }) === 0;
}

export function removeNonEnglishChars(keyword: string): string {
  if (keyword) {
    keyword = keyword.replace(/[\u0E00-\u0E7F]/g, '');
    return keyword.trim();
  } else {
    return keyword;
  }
}

export function keyPressCharacters_Company(event: KeyboardEvent): boolean {
  const char = event.key;

  // allow control keys (backspace, tab, arrows)
  if (char.length > 1) {
    return true;
  }

  const pattern = /^[a-zA-Z0-9 .,&()'\-]$/;

  if (pattern.test(char)) {
    return true;
  }

  event.preventDefault();
  return false;
}